import Icon from './icon';
import Text from './text';

export default {
  Icon,
  Text,
};



// WEBPACK FOOTER //
// ./src/app/components/logo/index.js